import React, { useState, useEffect } from "react";
import TextField from "../../../components/inputs/textfield";
import "./style.css";
import "../../public/advisors/style.css";
import { expertManPowerList } from "../user.api";
import Loader from "../../../components/loader/loader";
import BreadCrumpBack from "../../../components/navigator/back";
let count = 100;
export default function ExpertManPowerList(props) {
  const [isActive, setIsActive] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const isLoggedIn = Boolean(
    props?.state?.payload ||
    localStorage.getItem("token") ||
    localStorage.getItem("payload") ||
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("payload")
  );
  const listData = () => {
    expertManPowerList().then((res) => {
      let dir = res.data;
      setIsActive(false);
      let finalData = [];
      // dir.forEach((item) => {
      //   if (
      //     item.expert_manpower?.is_resource_person === 0 &&
      //     item.expert_manpower?.admin_status === 4
      //   ) {
      //     finalData.push(item);
      //   }
      // });

      setSearchData(dir);
      console.log(searchData);

      setIsActive(false);
    });
  };
  const [data, setData] = useState([]);
  useEffect(() => {
    listData();
  }, []);

  return (
    <div className="tender bg-tender">
      <Loader open={isActive} />
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">
            {props.state.language === "ma"
              ? "എസ്പെർട് മാൻപവർ"
              : "Expert Manpower"}
          </div>
        </div>
        <BreadCrumpBack />
      </div>
      <div className="container p-50">
        <div className="res-page-cont">
          <div className="row tender-box">
            {/* <div className="col-xs-12 col-sm-3">
              <div className="form-group has-search">
                <span className="fa fa-search form-control-feedback"></span>
                <input type="text" className="form-control" placeholder="Search" />
              </div>
            </div> */}
            <div className="new-res-tile-cont">
              {searchData.length !== 0 ? (
                <div className="container adbox mt-3">
                  <div className="org-sub-containers row row-cols-md-2 row-cols-lg-3 row-cols-1">
                    {searchData?.map((item) => (
                      <div key={item.user_id} className="core-item col">
                        <div className="d-flex justify-content-center">
                          <img
                            className="org-avatar"
                            src={`${result}${item?.photo}`}
                            alt=""
                          />
                        </div>
                        <div className="org-title">{`${item?.title} . ${item?.first_name} ${item?.last_name}`}</div>
                        {isLoggedIn && (
                          <div className="mt-2 d-flex justify-content-center">
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={() => props.history.push(`/expert-manpower/${item?.user_id}`)}
                            >
                              View More
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <>
                  <div className="no-data">
                    <img src="resources/img/no1.png" alt="" />
                    <h4>No Records Found..!!</h4>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
